<template>
    <div class="consultation">
        <!--导航栏-->
        <navbar :transparent="isTransparent" activeTo="Home"></navbar>
        <Spin size="large" fix v-if="spinShow"></Spin>
        <div class="-mob-share-ui"  style="display: none">
            <ul class="-mob-share-list">
                <li class="-mob-share-weibo"><p>weibo</p></li>
                <li class="-mob-share-weixin"><p>wechat</p></li>
                <li class="-mob-share-google"><p>google+</p></li>
                <li class="-mob-share-pocket"><p>Pocket</p></li>
                <li class="-mob-share-facebook"><p>Facebook</p></li>
                <li class="-mob-share-twitter"><p>Twitter</p></li>
                <li class="-mob-share-tumblr"><p>Tumblr</p></li>
            </ul>
            <div class="-mob-share-close">Canel</div>
        </div>
        <div class="-mob-share-ui-bg"></div>
        <section class="part_1">
            <h1>{{new_content.title}}</h1>
            <!--MOB SHARE BEGIN-->
            <div>
                <span>{{$t('consultation_date')}}:{{new_content.add_time}}</span>
                <a class="right -mob-share-open" @click="init"  style="padding-left: 35px;" >
                    <img class="right3" src="../../assets/home/share_normal.png" alt="share" width="16">
                    <span>{{$t('consultation_Share')}}</span>
                </a>
            </div>
            <div class="part_1_img">
                <img :src="new_content.img" width="100%">
            </div>
            <p v-html="new_content.content" style="text-align: justify"></p>
        </section>
        <div style="clear: both"></div>
        <section class="part_2">
            <h1 v-show="showThislike">{{$t('consultation_related_articles')}}</h1>
            <div class="relative_content" v-for="(item,key) in new_list" :key="key">
                <div class="relative_item1">
                    <a @click="detail(item.cms_id)"><img :src="item.img"></a>
                </div>
                <div class="relative_item2">
                    <a @click="detail(item.cms_id)"><h3>{{item.title}}</h3></a>
                    <p v-html="item.content"></p>
                </div>
            </div>
        </section>
        <BackTop>
            <div class="top">
                <img src="../../assets/backtop/top.png">
                <p style="">{{$t('top_btn')}}</p>
            </div>
        </BackTop>
        <a href="http://ifree.ly/support" target="_blank">
            <BackTop :height="100" :bottom="110">
                <div class="top">
                    <img src="../../assets/backtop/service.png">
                    <p>{{$t('Service_btn')}}</p>
                </div>
            </BackTop>
        </a>
    </div>
</template>
<script>
    import Signature from '../../lib/Signature'
    import navbar from '../Common/Navbar.vue'
    export default {
        data () {
            return {
                spinShow:true,
                NoShareShow:true,
                isTransparent:false,
                like_selected:false,
                ShareShow:false,
                share:true,
                new_content:[],
                new_list:[],
                good_num:1,
                if_good:false,
                title:'',
                go:0,
                go_toal:'',
                showThislike:true
            }
        },
        components: {
            navbar
        },
        created (){
            // 获取文章资讯
            this.getNEWContent ()
        },
        methods: {
            detail(id){
                this.$router.push({
                    name: 'ConsultationDetails',
                    query:  {
                        cms_id: id
                    }
                })
                this.getNEWContent ()
            },
            // 获取文章资讯
            getNEWContent () {
                let self = this
                const module = 'index.php/cms_content'
                let data = {}
                data.cms_id = this.$route.query.cms_id
                data.lang = this.$i18n.locale
                data.user_id = this.Local.getUserId()
                data.sub_time = Signature.timestamp()
                data.sign = Signature.create(module, data.sub_time)
                self.$http.get(process.env.BASEURL + module, {params: data}).then(function (resp) {
                    if (parseInt(resp.data.code) === 2000 ) {
                        self.spinShow = false
                        console.log(resp.data.data)
                        self.new_content = resp.data.data.content
                        //存题目
                        self.Local.set('title',self.new_content.title)
                        self.good_num = resp.data.data.content.good
                        self.new_list = resp.data.data.list
                        self.if_good = resp.data.data.if_good
                        if(self.new_list.length ===0) {
                            self.showThislike = false
                        }else{
                            self.showThislike = true
                        }
                    }
                })
            },
            // 分享功能
            init: function () {
                let url = 'http://f1.webshare.mob.com/code/mob-share.js?appkey=251512b0dde4e'
                let script = document.createElement('script')
                script.setAttribute('src', url)
                script.setAttribute('id', '-mob-share')
                document.getElementsByTagName('head')[0].appendChild(script)
            },
            // 刷新页面
            initData () {
                this.go = this.Local.get('go')
                if(!this.go) {
                    this.Local.set('go', 1)
                    this.$router.go(0)
                }else{
                    this.Local.unset('go')
                }
            }
        },
        created () {
            // 获取内容
            this.getNEWContent()

            // 获取title
            this.title = this.Local.get('title')

            //分享功能
            this.init()

            //刷新
            this.initData ()
        }
    }
</script>
<style lang="scss">
    @import "../../scss/_consultation.scss";
</style>



// WEBPACK FOOTER //
// ConsultationDetails.vue?1972135d